import BgEllipse from "@assets/icons/bg-ellipse-2.svg";
import { cn } from "@utils/tailwind.util";
import { ReactNode } from "react";

interface Props {
  className?: string;
  mainIcon: ReactNode;
  overlayIcon: ReactNode;
  overlayIconBackground: string;
}

export function ImageSection({
  className = "",
  mainIcon,
  overlayIcon,
  overlayIconBackground,
}: Props) {
  return (
    <div
      className={cn(
        "relative flex flex-col items-center w-full h-[64px] pointer-events-none",
        className
      )}
    >
      {overlayIcon && (
        <div
          className={cn(
            "absolute top-[14px] left-1/2 -translate-x-1/2 flex justify-center items-center flex-shrink-0 w-[26px] h-[26px] rounded-[50%] z-30",
            overlayIconBackground
          )}
        >
          {overlayIcon}
        </div>
      )}
      {mainIcon}
      <BgEllipse className="absolute top-0 w-full z-10" />
    </div>
  );
}
